#import "./requisition/fragments.graphql"

# Caller's inbox. Page on the server. Kind chips send filter.category.
# Load once, refetch after a write.
# Add a kind: spread its list fragment from InboxListItemFields.
query inbox($filter: InboxFilter, $paging: InboxPaging) {
  inbox(filter: $filter, paging: $paging) {
    total
    counts {
      category
      count
    }
    items {
      # Repeat interface fields: Jest's Apollo mock cache does not apply
      # InboxItem fragments onto the concrete item types.
      id
      kind
      owedAs
      since
      slaHours
      overdue
      ...InboxListItemFields
      ...RequisitionApprovalInboxListFields
      ...RequisitionExceptionReasonInboxListFields
    }
  }
}
